import { Option } from "../types/option";
import { deviceTypeOptions } from "./selectOptions";
import { CostsCalculations } from "../types/costsCalculations";
import { CostsConfig } from "../types/costsConfig";
import { TFunction } from "i18next";
import { ActivityData } from "../types/chartData";
import { InventoryData, Status } from "../types/inventoryData";
import { enGB, de, da, es, fr } from "date-fns/locale";

interface IdTokenClaims {
  tfp?: string;
  acr?: string;
}
export function compareIssuingPolicy(
  idTokenClaims: IdTokenClaims,
  policyToCompare: string
): boolean {
  let tfpMatches = idTokenClaims["tfp"] === policyToCompare.toLowerCase();
  let acrMatches = idTokenClaims["acr"] === policyToCompare.toLowerCase();
  return tfpMatches || acrMatches;
}
export function formatDate(dateString: string): number {
  const date = new Date(dateString).getTime();
  return date;
}

export const findLabelByValue = (value: number, array: Option[]): string => {
  let filter = array.find((a) => a.value === value);
  if (!filter) return "Unknown";
  return filter.label;
};


export const calculateCostsPerYear = ({
  costsConfig,
}: {
  costsConfig: CostsConfig;
}): CostsCalculations => {
  let directCosts: number =
    (costsConfig.avgEmployeeSalaryUSD / 20) *
    costsConfig.avgNumSickLeaves *
    costsConfig.numEmployees;
  let indirectCosts: number = directCosts * costsConfig.indirectCostsMultiplier;
    let msd: number = costsConfig.msdPercentage/100 * indirectCosts;
  let msdDays: number =
      costsConfig.msdPercentage * costsConfig.avgNumSickLeaves * costsConfig.numEmployees;
  let mlicosts: number = msd * 0.6;
  let mliDays: number = msdDays * 0.6;
    let effectcosts:number = mlicosts * 0.15;
    let effectDays:number = mliDays * 0.15;
    let numEmployees:number = costsConfig.numEmployees*costsConfig.msdPercentage/100 *0.6;
    let subsCost:number = 12*costsConfig.subscriptionCostUSD*(costsConfig.nBacks+costsConfig.nElbows);
    let savings:number = effectcosts- subsCost;
    let roi:number = savings/subsCost;

  return {
    directCostsPerYear: Math.round(directCosts),
    indirectCostsPerYear: Math.round(indirectCosts),
    costsMSD: Math.round(msd),
    daysMSD: Math.round(msdDays),
    costsMLIRelated: Math.round(mlicosts),
    daysMLIRelated: Math.round(mliDays),
    costsEffect: Math.round(effectcosts),
    daysEffect: Math.round(effectDays),
    numEmployees: Math.round(numEmployees),
    subsCost: Math.round(subsCost),
    savings: Math.round(savings),
      valueROI: roi
  };
};

export const getTranslatedDeviceTypes = (
  value: number[],
  translation: (t: string) => string
) => {
  let array: string[] = [];
  value.forEach((element) => {
    array.push(translation(findLabelByValue(element, deviceTypeOptions)));
  });
  return array.join(", ");
};

export const getTypesWithDisabledProperty = (
  availableTypes: number[],
  allTypes: Option[]
) => {
  if (availableTypes.length === 0) return allTypes;
  return allTypes.map((type) => ({
    ...type,
    disabled: !availableTypes.includes(type.value),
  }));
};


//TODO remove any when Carlos takes over.
export const getColor = (
  actitvity: any,
  selected: string | null,
  t: TFunction,
  attribute?: string
) => {
  let opacity = 1;

  let opacitySelected = selected === actitvity.name;

  return getColorByValue(actitvity.value,attribute, opacitySelected)
 
};

export const getColorByValue = (value: number, metric: string = "MLI", opaque: boolean = false, selectedAll = false) => {
  var opacity;
  if (opaque) opacity = 1;
  else opacity = 0.2;
  if(selectedAll) opacity = 1;

  // Get colors for dashboard charts
  if (metric === "MLI"){
    if (value >= 7) return `rgba(255, 99, 132, ${opacity})`; // Red
    if (value >= 3.77) return `rgba(255, 206, 86, ${opacity})`; // Yellow
    return `rgba(75, 192, 192, ${opacity})`; // Green

  } else
  {
    if (value >= 4) return `rgba(255, 99, 132, ${opacity})`; // Red
    if (value >= 3) return `rgba(255, 206, 86, ${opacity})`; // Yellow
    return `rgba(75, 192, 192, ${opacity})`; // Green
  }
  
};

export const getColorByEvolution = (value: number) => {
  if (value > 0) return "rgba(75, 192, 192, 1)"; // Green
  if (value < 0) return "rgba(255, 99, 132, 1)"; // Red
}
export const formatCurrency = (amount : number) => amount.toLocaleString("de-DE", { style: "currency", currency: "EUR" });
export const roundNumberToStr = (value:number, absolute:boolean, decimals:number) => {
  if (absolute) return Math.abs(value).toFixed(decimals);
  return value.toFixed(decimals);
}

export const relativeChange = (newValue: number, oldValue:number) => {
  if (oldValue < 1) return 0;
  return (newValue - oldValue)/oldValue * 100;
}

export const layoutClasses = {
  root: 'layout__root',
  main: 'layout__main',
  header: 'layout__header',
  content: 'layout__main__content',
  hasSidebar: 'layout__has__sidebar',
};

export const getProductStatusColor = (item: InventoryData) => {
  if (item.status == Status.Available) return "#008000";
  if (item.status == Status.InUse) return "#2196F3";
  if (item.status == Status.QA) return "#FF9800";
  if (item.status == Status.Defect) return "#F44336";
};

export const getSelectedRows = (filteredRows: InventoryData[]) => {
  return filteredRows.filter((r) => r.isSelected === true);
};

export const clearSelectedRows = (prev: InventoryData[]) => {
  const newFilteredRows = prev.map((oldrow) => {
    return {
      ...oldrow,
      isSelected: false,
    };
  });
  return newFilteredRows;
};

export const dateTimeLocales: any = { en: enGB, de: de, da: da, es: es, fr: fr };